/* eslint-disable react-hooks/exhaustive-deps */
import {
  BottomNavigation,
  BottomNavigationAction, IconButton,
  Paper,
  Theme,
  Typography,
  useTheme
} from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { basicNavItems, getMenuItemIconConfig } from "../../../constants/navigationItems";
import { ROUTES } from "../../../constants/routes";
import { OnboardingStep, useOnboarding } from "../../../contexts/OnboardingContext";
import CreateTransactionIcon from "../icons/CreateTransactionIcon";

const getFirstPathPart = (pathname: string) => {
  const path = pathname.split("/")[1];
  return path ? `/${path}` : ROUTES.DASHBOARD;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FloatingButton = () => {
  const theme: Theme = useTheme();

  return (
    <IconButton
      sx={{
        position: "absolute",
        transform: "translateY(-50%)",
        width: 50,
        height: 50,
        backgroundColor: theme.palette.common.white,
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        boxShadow: theme.shadows[2],
        zIndex: theme.zIndex.drawer - 1,
        padding: 0,
      }}
      href={ROUTES.CREATE_BASIC_TRANSACTION}
    >
      <CreateTransactionIcon />
    </IconButton>
  );
};

const BottomNavigator = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [value, setValue] = React.useState(getFirstPathPart(location.pathname));
  const { isOnboardingActive, currentStep } = useOnboarding();

  // Increase z-index when onboarding is on ADD_TRANSACTION step to show above overlay
  const isAddTransactionStep = isOnboardingActive && currentStep === OnboardingStep.ADD_TRANSACTION;
  const bottomBarZIndex = isAddTransactionStep ? theme.zIndex.modal + 50 : theme.zIndex.drawer - 1;

  useEffect(() => {
    setValue(getFirstPathPart(location.pathname));
  }, [location.pathname]);

  const handleBottomNavChange = (_: React.ChangeEvent<{}>, newValue: string) => {
    setValue(newValue);
    navigate(newValue);
  };

  return (
    <>
      <Paper
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: "transparent",
          boxShadow: "none",
          zIndex: theme.zIndex.appBar,
        }}
        elevation={0}
      >
        <Paper
          elevation={6}
          data-onboarding-id="onboarding-add-transaction"
          sx={{
            position: "fixed",
            zIndex: bottomBarZIndex,
            borderTop: `1px solid ${theme.palette.divider}`,
            bottom: 0,
            left: 0,
            right: 0,
          }}
        >
          <BottomNavigation
            showLabels
            value={value}
            onChange={handleBottomNavChange}
          >
            {basicNavItems
              .filter((item) => !item.hidden)
              .map((item, index) => {
                const iconConfig = getMenuItemIconConfig(item.key, theme);
                const IconComponent = iconConfig.component;
                const getItemLabel = () => {
                  return (
                    <Typography sx={{ fontWeight: value === item.path ? 700 : 500, fontSize: 12, ...item.textStyle }}>
                      {t(item.translationKey, { ns: 'navigation' })}
                    </Typography>
                  );
                };

                return (
                  <BottomNavigationAction
                    key={item.key}
                    value={item.path}
                    label={getItemLabel()}
                    icon={<IconComponent {...iconConfig.props} sx={{ fontSize: 24 }} />}
                    sx={{
                      paddingInline: 1,
                      whiteSpace: "nowrap",
                      opacity: item.hidden ? 0 : 1,
                      pointerEvents: item.hidden ? "none" : "auto"
                    }}
                  />
                );
              })}
            {/* <FloatingButton /> */}
          </BottomNavigation>
        </Paper>
      </Paper>
    </>
  );
};

export default BottomNavigator;
